import React from "react";
import {Grid, Card, Typography} from "@mui/material";
import {Link} from "react-router";
import type {Theme} from "@mui/material";

interface BookingConfirmationProps {
    bookingNumber?: string;
    instantApproval: boolean;
    brokered: boolean;
}

const blueCardSx = {
  backgroundColor: 'rgba(216, 248, 255, 1)',
  marginTop: '1.5em',
} as const;

// Matches theme.components.returnToText from globalThemes.js
const bottomLinkSx = (theme: Theme) => ({
    color: theme.palette.secondary.main,
    marginBottom: '2em',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '0.71rem',
    lineHeight: '100%',
    textTransform: 'uppercase',
    '@media(max-width: 39.28em)': {
        marginBottom: '0.5em',
    },
});

const BookingConfirmation = (props: BookingConfirmationProps) => {
    const {bookingNumber, instantApproval, brokered} = props;

    const instantApprovalMessage = "This order has been approved and your payment is processing. Please check the My Bookings page for details about your booking.";
    const reserveSpaceMessage = "This order has been submitted for approval. Please check the My Bookings page for the status of this order. You will not be charged until the order is approved"

    const shouldShowBookingNumber = (brokered || instantApproval) && bookingNumber;

    return <Grid item>
        <Grid className="ss-byb-content">
            <Typography variant={'h5'} color={'textPrimary'}>Thanks for your order</Typography>
            <Card className="ss-byb-card" sx={blueCardSx}>
                <Typography variant="h6">{ shouldShowBookingNumber ? `Booking #${bookingNumber}`: 'Confirmation' }</Typography>
                <Typography variant="body2">{ instantApproval ? instantApprovalMessage : reserveSpaceMessage }</Typography>
            </Card>
        </Grid>
        <Link to="/bookings" style={{textDecoration: 'none'}}>
            <Typography sx={bottomLinkSx}>VIEW MY BOOKINGS</Typography>
        </Link>
    </Grid>
}

export default BookingConfirmation;
